import * as unclaimed from './_unclaimed-abilities-please-take-ownership';

import * as access from './access';
import * as agentInstructions from './agentInstructions';
import * as agents from './agents';
import * as aiGovernance from './ai-governance';
import * as assets from './assets';
import * as aiSiteGen from './ai-site-generation';
import * as apps from './apps';
import * as authorization from './authorization';
import * as billing from './billing';
import * as aisbBuilding from './aisbBuilding';
import * as campaignBuilding from './campaignBuilding';
import * as pageBuilding from './pageBuilding';
import * as sharedServices from './sharedServices';
import * as comments from './comments';
import * as interactions from './interactions';
import * as modes from './modes';
import * as workspaceLibraries from './workspaceLibraries';
import * as pages from './pages';
import * as branching from './branching';
import * as publishing from './publishing';
import * as publishingBranchingReview from './publishing-branching-review';
import * as privateHosting from './privateHosting';
import * as elements from './elements';
import * as designer from './designer';
import * as ecomm from './ecomm';
import * as codeGen from './code-gen';
import * as customDomains from './custom-domains';
import {
  canAccessOptimizationSettings,
  canAccessOptimizationOrAnalytics,
  canSeeEditInVariationBlocker,
  canAccessEnterpriseOptimizationSettings,
  canAccessAntiFlickerTimeout,
  canAccessOfflineConversionTokens,
  canAccessOffSiteCustomMetric,
  canAccessEnterpriseOptimizeAnalyzeIntegrations,
  canAccessIntegrationsPanel,
  canManageTrackingSettings,
  canManageOptimizationExperiences,
  canManageOptimizationVariations,
  canManageOptimizationVariationState,
  canManageAnalyzeMetricEvents,
  canManageOptimizationIntegrations,
  canEditGoalElements,
  canAccessRedirectTests,
  canAccessLocaleAudience,
  canAccessAiSuggestions,
  canAccessAiSuggestionsComponentMain,
  canDeleteOptimizationWrappers,
  canRelaunchAb,
  canModifyStyleBlocksInOptimization,
  canModifyComponentsInOptimization,
  canModifyComponentInstanceInOptimization,
  canAccessAiInsights,
} from './optimization';
import {
  canModifyURLs,
  canModifyElementVisibility,
  canModifyImageElements,
  canUseLocalizationBrowserDetection,
  canEnableLocalePublishing,
  canEditLocalizedCanvasItem,
  canEditLocaleContent,
  canRequestAutoTranslateOnOpen,
  canAccessLocalizationCorruptionAudit,
  canAccessNewAuditPanelUI,
  hasUnrestrictedLocaleAccess,
  canUseAdvancedLocalization,
} from './localization';
import {
  canAccessAnalyticsPanel,
  canViewAnalyzeRightSidebar,
  canAccessAnalyzeVisualView,
  canViewDataExportsForAnalyze,
} from './analytics';
import * as components from './components';
import * as wxpTour from './wxpTour';
import * as variables from './variables';
import * as forms from './forms';
import * as cms from './cms';
import * as sync from './sync';
import {canAccessOrionAppsList} from './panelUpdates';
import * as sharing from './sharing';
import * as siteActivityLog from './siteActivityLog';
import {
  canAccessAeoSiteAudit,
  canAccessAeoContentAuthoring,
  canAccessAeoContentWorkflowToggle,
  canAccessAeoSiteAuditLocalization,
  canManageAeoRecommendations,
  canUseAgentInstructionsForContentRecommendations,
  canViewAeoRecommendationFeedback,
  canViewAeoSiteAudit,
  canViewSiteRecommendationConfiguration,
  canUpdateSiteRecommendationConfiguration,
  canViewAeoMeasurement,
  canManageAeoAnalytics,
  canViewAeoBrand,
  canManageAeoBrand,
  canViewAeoLLMConfig,
  canManageAeoLLMConfig,
  canAccessSeo,
} from './siteDiscovery';
import * as multiContextCanvas from './multi-context-canvas';
import * as structure from './structure';

export const abilityConfigs = {
  ...unclaimed,
  ...access,
  ...agentInstructions,
  ...agents,
  ...aiGovernance,
  ...assets,
  ...aiSiteGen,
  ...apps,
  ...authorization,
  ...billing,
  ...aisbBuilding,
  ...campaignBuilding,
  ...pageBuilding,
  ...sharedServices,
  ...comments,
  ...interactions,
  ...modes,
  ...workspaceLibraries,
  ...pages,
  ...branching,
  ...publishing,
  ...publishingBranchingReview,
  ...privateHosting,
  ...elements,
  ...designer,
  ...ecomm,
  ...components,
  ...wxpTour,
  ...variables,
  ...forms,
  ...cms,
  ...sync,
  ...sharing,
  ...siteActivityLog,
  ...codeGen,
  ...customDomains,
  ...multiContextCanvas,
  ...structure,

  // panels ui updates
  canAccessOrionAppsList,

  // optimization
  canAccessOptimizationSettings,
  canAccessOptimizationOrAnalytics,
  canSeeEditInVariationBlocker,
  canAccessEnterpriseOptimizationSettings,
  canAccessAntiFlickerTimeout,
  canAccessOfflineConversionTokens,
  canAccessOffSiteCustomMetric,
  canAccessEnterpriseOptimizeAnalyzeIntegrations,
  canAccessIntegrationsPanel,
  canManageTrackingSettings,
  canManageOptimizationExperiences,
  canManageOptimizationVariations,
  canManageOptimizationVariationState,
  canManageAnalyzeMetricEvents,
  canManageOptimizationIntegrations,
  canEditGoalElements,
  canAccessRedirectTests,
  canAccessLocaleAudience,
  canAccessAiSuggestions,
  canAccessAiInsights,
  canDeleteOptimizationWrappers,
  canAccessAiSuggestionsComponentMain,
  canRelaunchAb,
  canModifyStyleBlocksInOptimization,
  canModifyComponentsInOptimization,
  canModifyComponentInstanceInOptimization,

  // localization
  canModifyURLs,
  canModifyElementVisibility,
  canModifyImageElements,
  canUseLocalizationBrowserDetection,
  canEnableLocalePublishing,
  canEditLocalizedCanvasItem,
  canEditLocaleContent,
  canRequestAutoTranslateOnOpen,
  canAccessLocalizationCorruptionAudit,
  canAccessNewAuditPanelUI,
  hasUnrestrictedLocaleAccess,
  canUseAdvancedLocalization,

  //analytics
  canAccessAnalyticsPanel,
  canViewAnalyzeRightSidebar,
  canAccessAnalyzeVisualView,
  canViewDataExportsForAnalyze,

  // site discovery
  canAccessAeoContentAuthoring,
  canAccessAeoContentWorkflowToggle,
  canAccessAeoSiteAudit,
  canAccessAeoSiteAuditLocalization,
  canManageAeoRecommendations,
  canUseAgentInstructionsForContentRecommendations,
  canViewAeoRecommendationFeedback,
  canViewAeoSiteAudit,
  canViewSiteRecommendationConfiguration,
  canUpdateSiteRecommendationConfiguration,
  canViewAeoMeasurement,
  canManageAeoAnalytics,
  canViewAeoBrand,
  canManageAeoBrand,
  canViewAeoLLMConfig,
  canManageAeoLLMConfig,
  canAccessSeo,
} as const;
